import React from 'react';

const AboutPage = () =>   <h1>Hi, I'm the about page!</h1>


export default AboutPage;